/* eslint-disable */
import React, { useState } from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import QuoteModal from './QuoteModal';
import './Services.css';
import { useContent } from '../../context/ContentContext';

const Services = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedService, setSelectedService] = useState(null);
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  const {features } = useContent();

  const services = features && features.length > 0 ? features : [
    {
      id: 4,
      title: 'Protection & Peacebuilding',
      category: 'peace',
      image: '/assets/img/farmo/peacebuilding.jpg',
      description: 'Fostering gender equality, reconciliation, and community dialogues for lasting peace.',
      longDescription: 'Our program increases women\'s participation in agriculture, facilitates dialogues between displaced persons and host communities, conducts sensitization campaigns on legal frameworks, and establishes community-based protection committees.',
      impact: '100+ peace dialogues facilitated, 50+ protection committees formed',
      icon: 'ri-hand-peace-line'
    },
    {
      id: 5,
      title: 'Youth & Women Empowerment',
      category: 'empowerment',
      image: '/assets/img/farmo/women-empowerment.jpg',
      description: 'Entrepreneurship training, vocational skills, and leadership development.',
      longDescription: 'We provide training in business planning and financial literacy, support youth- and women-led enterprises, deliver hands-on vocational training, and build networks of empowered women and youth leaders.',
      impact: '5,000+ youth trained, 1,000+ women entrepreneurs supported',
      icon: 'ri-women-line'
    },
    {
      id: 6,
      title: 'Environmental Protection',
      category: 'environment',
      image: '/assets/img/farmo/environment.jpg',
      description: 'Reforestation, soil conservation, and climate change adaptation strategies.',
      longDescription: 'Our environmental initiatives include reforestation and afforestation projects, soil and water conservation programs, renewable energy adoption, climate change awareness campaigns, and disaster risk reduction strategies.',
      impact: '50,000+ trees planted, 100+ water projects completed',
      icon: 'ri-earth-line'
    },
    {
      id: 7,
      title: 'Emergency Response',
      category: 'emergency',
      image: '/assets/img/farmo/emergency.jpg',
      description: 'Rapid relief for IDPs, refugees, and vulnerable populations during crises.',
      longDescription: 'We provide seed distribution, food aid, and livelihood recovery programs during emergencies, always linked to long-term resilience strategies to prevent dependency.',
      impact: '10,000+ families assisted in emergencies',
      icon: 'ri-flashlight-line'
    }
  ];

  const categories = [
    { id: 'all', name: 'All Programs' },
    { id: 'agriculture', name: 'Food Security' },
    { id: 'health', name: 'Health & Nutrition' },
    { id: 'education', name: 'Education' },
    { id: 'peace', name: 'Peacebuilding' },
    { id: 'empowerment', name: 'Empowerment' },
    { id: 'environment', name: 'Environment' },
    { id: 'emergency', name: 'Emergency' }
  ];

  const filteredServices = activeCategory === 'all' 
    ? services 
    : services.filter(service => service.category === activeCategory);

  const handleRequestQuote = (service) => {
    setSelectedService(service);
    setIsQuoteModalOpen(true);
  };

    const getImageUrl = (imageUrl) => {
  if (!imageUrl) return '/assets/img/placeholder.png';
  
  if (imageUrl.startsWith('/uploads')) {
    if (process.env.NODE_ENV === 'development') {
      return `http://localhost:5000${imageUrl}`;
    }
    const apiUrl = 'https://farmo.zuddo.biz/api';
    const backendOrigin = apiUrl.replace(/\/api\/?$/, '');
    return `${backendOrigin}${imageUrl}`;
  }
  if (imageUrl.startsWith('/assets/')) {
    return imageUrl;
  }
  return imageUrl;
};

  return (
    <section className="services-page section" id="services">
      <div className="container">
        <div className="services-page__header">
          <span className="section__subtitle">OUR PROGRAMS</span>
          <h2 className="section__title">
            Transforming Lives Through <span className="highlight">Sustainable Solutions</span>
          </h2>
          <p className="services-page__description">
            Discover how our integrated programs are building resilience, food security, and lasting peace across South Sudan.
          </p>
        </div>

        <div className="services-page__categories">
          <div className="category-filters">
            {categories.map(category => (
              <button
                key={category.id}
                className={`category-filter ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>

        <div className="services-page__grid">
          {filteredServices.map(service => (
            <div key={service.id} className="program-card">
              <div className="program-card__image">
                <img src={getImageUrl(service.image)} alt={service.title} />
                <div className="program-card__icon">
                  <i className={service.icon}></i>
                </div>
              </div>
              <div className="program-card__content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <div className="program-card__impact">
                  <i className="ri-bar-chart-2-line"></i>
                  <span>{service.impact}</span>
                </div>
                <div className="program-card__actions">
                  <button 
                    className="btn-learn-more"
                    onClick={() => handleRequestQuote(service)}
                  >
                    Learn More
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <QuoteModal 
        service={selectedService}
        isOpen={isQuoteModalOpen}
        onClose={() => {
          setIsQuoteModalOpen(false);
          setSelectedService(null);
        }}
      />
    </section>
  );
};

export default Services;